import _ from 'lodash';
import * as actionTypes from '../actions/actionTypes';

const INITIAL_STATE = {
  // current user subscriptions
  optInGroups: {},
  selectedGroupIds: [],
  checkedShowIncidentSub: false,
  shouldShowIncidentSub: false,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case actionTypes.GET_GROUP_SUBSCRIPTION.SUCCESS: {
      const optInGroups = _.get(action.payload, 'optInGroups', {});
      const selectedGroupIds = _.get(action.payload, 'selectedGroupIds', []);
      return {
        ...state,
        optInGroups,
        selectedGroupIds,
      };
    }
    case actionTypes.CLEAR_SUBSCRIPTION_DATA: {
      const { checkedShowIncidentSub, shouldShowIncidentSub } = state;
      return {
        ...INITIAL_STATE,
        checkedShowIncidentSub,
        shouldShowIncidentSub,
      };
    }
    case actionTypes.SET_SHOULD_SHOW_INCIDENT_SUB: {
      return {
        ...state,
        checkedShowIncidentSub: true,
        shouldShowIncidentSub: action.payload,
      };
    }
    default:
      return state;
  }
};
